import React from 'react'
import { useHistory } from 'react-router-dom'

import { Col, Row } from 'antd'

import { InsurancePremiumDetails } from 'core/application/expenses/getInsurancePremiumDetails'

import { ROUTE_PATHS } from 'common/routePaths'

import Avatar from '../../../../common/components/dataDisplay/Avatar'
import Card from '../../../../common/components/dataDisplay/Card'
import Modal from '../../../../common/components/feedback/Modal'
import Button from '../../../../common/components/general/Button'
//
import Icon from '../../../../common/components/general/Icon'

type EditInsurancePremiumEndDateModalProps = {
  premiumId: string
  expenseTypeId: number
  recurringExpenseId: string
  planPeriodId: string
  insurancePremiumDetails: InsurancePremiumDetails
  onCancel: () => void
  onOk: () => void
  visible: boolean
  handleEndDateChange: () => void
}

const EditInsurancePremiumModal: React.FC<EditInsurancePremiumEndDateModalProps> = (props) => {
  const history = useHistory()

  return (
    <Modal visible={props.visible} closable={true} onCancel={props.onCancel} title={'Update Premium'} footer={false}>
      <p>Choose one of the options below.</p>
      <Row className="mb-8">
        <Col span={24}>
          <Card
            title={
              <>
                <Avatar
                  size="large"
                  className="center_avatar insurance-premium-avatar-premium"
                  icon={<Icon className="far fa-money-check-alt color-green-6" />}
                />
                <div>Report a change in premium amount.</div>
              </>
            }
          >
            <Row justify="start">
              <Col span={24}>
                <p>Enter a new premium amount for changes including:</p>
                <ul>
                  <li> Adding or removing a spouse/dependent from your insurance policy</li>
                  <li> New subsidy or premium tax credits that change the amount you pay each month for your policy</li>
                  <li> The premium amount you listed previously was incorrect</li>
                </ul>
                <Button
                  type="default"
                  iconPosition="right"
                  icon="far fa-arrow-right"
                  onClick={() => {
                    history.push(
                      `${ROUTE_PATHS.ELIGIBLE_EMPLOYEE_EDIT_PREMIUM_EXPENSE}/?expenseTypeId=${props.expenseTypeId}&planPeriodId=${props.planPeriodId}&recurringExpenseId=${props.recurringExpenseId}&premiumId=${props.premiumId}`,
                    )
                  }}
                >
                  Change premium amount
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Card
            title={
              <>
                <Avatar
                  size="large"
                  className="center_avatar insurance-premium-avatar-premium"
                  icon={<Icon className="far fa-calendar-day color-green-6" />}
                />
                <div>Change your policy's end date.</div>
              </>
            }
          >
            <Row justify="start">
              <Col span={24}>
                <p>Enter when your policy ends (like when you purchased a replacement policy for the next year).</p>
                <Button
                  type="default"
                  iconPosition="right"
                  icon="far fa-arrow-right"
                  onClick={props.handleEndDateChange}
                >
                  Change end date
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Modal>
  )
}

export default EditInsurancePremiumModal
